export default function callEachUntilSuccess(promises) {
  return promises[0]().catch((err) => {
    if (promises.length > 1) {
      return callEachUntilSuccess(promises.slice(1))
    }
    throw err
  })
}
